import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MetricActionType } from '../models/metrics';
import { ReportFileType, StoreLocationByDcReportCriteria } from '../models/report.model';
import { metricsReportDataHub } from '../utils/metrics-util';
import { BaseService } from './base.service';

@Injectable()
export class StoreLocationReportService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.storeLocationReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public exportByDc(criteria: StoreLocationByDcReportCriteria): Observable<any> {
    const url = this.getFullUrl(this.envService.exportDc);
    const exportType =
      criteria.fileType === ReportFileType.CSV ? MetricActionType.EXPORT_CSV : MetricActionType.EXPORT_XLSX;
    const metrics = metricsReportDataHub([this.envService.url, this.envService.export], exportType);

    return this.http.post<any>(url, criteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }
}
